
<div
  :class="classes(n(), n(`--${shape}`))"
  :style="avatarStyle"
  role="img"
  :aria-label="alt"
>
  <!-- 默认头像：如果没有 src、图片加载失败，或（图片加载中且 showDefaultOnLoad 为 true）时显示默认头像 -->
  <div
    v-if="!src || imageError || (src && !imageLoaded && showDefaultOnLoad)"
    :class="n('default-icon')"
  >
    <img
      :src="defaultAvatarSrc"
      :alt="alt"
      :class="n('default-icon-image')"
    >
  </div>
  <!-- 图片头像：如果提供了 src 且未出错，则尝试加载图片 -->
  <img
    v-if="src && !imageError"
    ref="imageElement"
    :src="src"
    :alt="alt"
    :class="n('image')"
    :style="{ opacity: imageLoaded ? 1 : 0 }"
    @load="handleImageLoad"
    @error="handleImageError"
  >
</div>
